module.exports = __webpack_public_path__ + "img/qfm_banner_title.36e51364.png";